import { paperClasses, cardContentClasses, cardHeaderClasses, Table, styled, SimpleWidgetCard, Image } from "@tm/components"

export const LatestActivitiesWidgetCard = styled(SimpleWidgetCard, {
    name: "LatestActivitiesWidget",
    slot: "root",
    overridesResolver: (_, styles) => styles.root,
})({
    height: "38em",
    [`& .${paperClasses.root}`]: {
        padding: "0.5em",
        [`& .${cardContentClasses.root}`]: {
            height: "calc(100% - 2em)",
        },
    },
    [`.${cardHeaderClasses.action}`]: {
        marginRight: 0,
    },
})

export const LatestActivitiesTable = styled(Table)(() => ({
    paddingRight: "4px",
    maskImage: "linear-gradient(to bottom, #000 50%, rgba(0,0,0,0))",
    maskRepeat: "no-repeat",
    maskSize: "100% 100%",
    transition: "all 500ms ease-in-out",
    "&:hover": {
        maskSize: "100% 200%",
    },
}))

export const VehicleImage = styled(Image)({
    width: "90%",
    "&.error-image": {
        height: "80%",
    },
})
